import { useMutation, useQuery } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import {
  createUserWorkTime,
  getUserWorkTime,
  removeUserWorkTime,
  updateUserWorkTime,
} from './UserWorkTimeController.service';
import { queryClient } from '@/Root';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useCreateUserWorkTime() {
  const queryChanel = useQueryChanel();

  return useMutation(createUserWorkTime, {
    onSuccess() {
      queryChanel({ resetQueries: [['users-work-time']] });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useUserWorkTime(id?: number) {
  const cache = queryClient.getQueryData(['users-work-time', id]);

  return useQuery(['users-work-time', id], () => getUserWorkTime(id), {
    enabled: !!id && !cache,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useUpdateUserWorkTime() {
  const queryChanel = useQueryChanel();

  return useMutation(updateUserWorkTime, {
    onSuccess() {
      queryChanel({ resetQueries: [['users-work-time']] });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useRemoveUserWorkTime() {
  const queryChanel = useQueryChanel();

  return useMutation(removeUserWorkTime, {
    onSuccess() {
      notification.success({
        message: 'Horário removido com sucesso!',
      });

      queryChanel({ resetQueries: [['users-work-time']] });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
